// | `LocalDateTime` type, and support for converting from UTC to a specific time zone.
import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dDate$dComponent from "../Data.Date.Component/index.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dJSDate from "../Data.JSDate/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTime from "../Data.Time/index.js";
import * as Data$dTime$dDuration from "../Data.Time.Duration/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Unscramble from "../Unscramble/index.js";
import {getJSDateComponentsLocal, utcToZonedTime, zoneExists} from "./foreign.js";
const $LocalDateTime = (_1, _2) => ({tag: "LocalDateTime", _1, _2});
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const TZLabel = x => x;
const LocalDateTime = value0 => value1 => $LocalDateTime(value0, value1);
const showTZLabel = Data$dShow.showString;
const showLocalDateTime = {show: v => DateUtils.formatISODate(v._1) + " " + DateUtils.formatISOTime(v._2)};
const parseTZLabel = str => {
  if (zoneExists(str)) { return Data$dMaybe.$Maybe("Just", str); }
  return Data$dMaybe.Nothing;
};
const udecodeTZLabel = {
  unsafeDecode: f => {
    const str = Unscramble.decodeString(f);
    if (zoneExists(str)) { return str; }
    return Unscramble.decodingError("Invalid time zone: " + Data$dShow.showStringImpl(str));
  }
};
const unsafeParseTZLabel = str => {
  if (zoneExists(str)) { return str; }
  return Partial._crashWith("unsafeParseTZLabel: Invalid TZLabel: " + Data$dShow.showStringImpl(str));
};
const utc = /* #__PURE__ */ zoneExists("UTC") ? "UTC" : /* #__PURE__ */ Partial._crashWith("unsafeParseTZLabel: Invalid TZLabel: \"UTC\"");
const localTime = v => v._2;
const localDate = v => v._1;
const fromTimeComponents = x => Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.hours >= 0 && x.hours <= 23
  ? Data$dMaybe.$Maybe("Just", Data$dTime.Time(x.hours))
  : Data$dMaybe.Nothing)(x.minutes >= 0 && x.minutes <= 59 ? Data$dMaybe.$Maybe("Just", x.minutes) : Data$dMaybe.Nothing))(x.seconds >= 0 && x.seconds <= 59
  ? Data$dMaybe.$Maybe("Just", x.seconds)
  : Data$dMaybe.Nothing))(x.milliseconds >= 0 && x.milliseconds <= 999 ? Data$dMaybe.$Maybe("Just", x.milliseconds) : Data$dMaybe.Nothing);
const fromDateComponents = x => {
  const $0 = Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.year >= -271820 && x.year <= 275759
    ? Data$dMaybe.$Maybe("Just", Data$dDate.exactDate(x.year))
    : Data$dMaybe.Nothing)(Data$dDate$dComponent.boundedEnumMonth.toEnum(x.month + 1 | 0)))(x.day >= 1 && x.day <= 31 ? Data$dMaybe.$Maybe("Just", x.day) : Data$dMaybe.Nothing);
  if ($0.tag === "Just") { return $0._1; }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const fromDateTimeComponents = x => Data$dMaybe.applyMaybe.apply((() => {
  const $0 = fromDateComponents(x);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", LocalDateTime($0._1)); }
  return Data$dMaybe.Nothing;
})())(fromTimeComponents(x));
const utcToLocalDateTime = dt => tz => {
  const local = utcToZonedTime(Data$dJSDate.fromDateTime(dt), tz);
  const v = fromDateTimeComponents(getJSDateComponentsLocal(local));
  if (v.tag === "Just") { return v._1; }
  if (v.tag === "Nothing") {
    return Partial._crashWith("utcToLocalDateTime(" + Data$dDateTime.showDateTime.show(dt) + ", " + Data$dShow.showStringImpl(tz) + "): returned invalid datetime: " + Data$dJSDate.dateMethodEff(
      "toISOString",
      local
    )());
  }
  $runtime.fail();
};
const getLogicalDay = tz => startOfDayOffset => t => utcToLocalDateTime((() => {
  const $0 = Data$dDateTime.adjust(Data$dTime$dDuration.durationHours)(-Data$dInt.toNumber(startOfDayOffset))(t);
  if ($0.tag === "Nothing") { return t; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
})())(tz)._1;
const utcToLocalDateTime$p = v => utcToLocalDateTime(v);
const localNow = dictMonadEffect => {
  const Monad0 = dictMonadEffect.Monad0();
  const bind1 = Monad0.Bind1().bind;
  const now = dictMonadEffect.liftEffect(() => {
    const a$p = Effect$dNow.now();
    return Data$dDateTime$dInstant.toDateTime(a$p);
  });
  const pure1 = Monad0.Applicative0().pure;
  return tz => bind1(now)(now1 => pure1(utcToLocalDateTime(now1)(tz)));
};
const eqTZLabel = Data$dEq.eqString;
const eqLocalDateTime = {eq: v => v1 => Data$dDate.eqDate.eq(v._1)(v1._1) && v._2._1 === v1._2._1 && v._2._2 === v1._2._2 && v._2._3 === v1._2._3 && v._2._4 === v1._2._4};
const encodeTZLabel = {encode: v => v};
const decodeTZLabel = {
  decode: f => bind(Foreign$dGeneric$dClass.readString(f))(str => {
    if (zoneExists(str)) { return pure(str); }
    return fail(Foreign.$ForeignError("ForeignError", "Invalid time zone: " + Data$dShow.showStringImpl(str)));
  })
};
export {
  $LocalDateTime,
  LocalDateTime,
  TZLabel,
  bind,
  decodeTZLabel,
  encodeTZLabel,
  eqLocalDateTime,
  eqTZLabel,
  fail,
  fromDateComponents,
  fromDateTimeComponents,
  fromTimeComponents,
  getLogicalDay,
  localDate,
  localNow,
  localTime,
  parseTZLabel,
  pure,
  showLocalDateTime,
  showTZLabel,
  udecodeTZLabel,
  unsafeParseTZLabel,
  utc,
  utcToLocalDateTime,
  utcToLocalDateTime$p
};
export * from "./foreign.js";
